export default {
  "wt-toggle": "_wt-toggle_xn78e2_1",
  "wt-toggle__slider": "_wt-toggle__slider_xn78e2_5",
  "wt-toggle__wrapper": "_wt-toggle__wrapper_xn78e2_11",
  "wt-toggle_size_xs": "_wt-toggle_size_xs_xn78e2_44",
  "wt-toggle_size_s": "_wt-toggle_size_s_xn78e2_62",
  "wt-toggle_size_m": "_wt-toggle_size_m_xn78e2_63",
  "wt-toggle_theme_light": "_wt-toggle_theme_light_xn78e2_75",
  "wt-toggle_theme_dark": "_wt-toggle_theme_dark_xn78e2_82"
};